import { appConfig } from "../config/config";
import CookieService from "../services/CookieService";
import { useAppSelector } from "../store/hooks";

const useAccount = () => {
  const {isNewUser,is_verified } = useAppSelector((data) => data.account);
  const profile = useAppSelector((data) => data.authVerify);
  const authenticated = CookieService.getCookie(appConfig.authAccessToken);
  const showTips = is_verified && isNewUser;
  return { showTips, isNewUser, authenticated, is_verified, profile };
};

export default useAccount;
